export default __webpack_public_path__ + "static/media/2014.3f104455.webp";